import axios from "axios";

const BASE_URL = "http://teamsapi.autoappy.com";

export const getEmployees = async () => {
  const response = await axios.get(
    `https://selflessly-nonradiative-mozella.ngrok-free.dev/employees`
  );

  return response.data;
};